import * as React from 'react';

const LoaderIconBallClipRotate = (props) => {
    return (
        <div className="la-ball-clip-rotate la-dark la-md">
            <div></div>
        </div>
    );
};

export default LoaderIconBallClipRotate;
